export function updateData(type, data){
	return {
		type: 'UPD_' + type,
		data
	};
}




// WEBPACK FOOTER //
// ./src/actions/actionCreators.js